module.exports = __webpack_public_path__ + "static/media/background.197f80d0.jpg";